// hooks/useClaims.js
import { useState, useEffect } from "react";
import API from "../../../utils/api";

export const useClaims = ({ ITEMS_PER_PAGE = 8, filterPaymentStatus, hasChat , unreadFirst }) => {
  const [claimsData, setClaimsData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({});

  const fetchClaims = async (page = currentPage, currentFilters = filters) => {
    setLoading(true);
    try {
      // Start with base params
      const params = { page, limit: ITEMS_PER_PAGE, ...currentFilters };

      // ✅ Apply filterPaymentStatus if provided
      if (filterPaymentStatus) {
        if (Array.isArray(filterPaymentStatus)) {
          params.paymentStatus = filterPaymentStatus.join(','); // API expects comma separated string
        } else {
          params.paymentStatus = filterPaymentStatus;
        }
      }
      if (hasChat === true) {
        params.hasChat = true;
      }
      if (unreadFirst === true) {
        params.unreadFirst = true;
      }
      const response = await API.get("/claims/own", { params });

      setClaimsData(response.data.data);
      setTotalPages(Math.ceil(response.data.totalCount / ITEMS_PER_PAGE));
    } catch (err) {
      setError("Failed to load claims");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchClaims(currentPage);
  }, [currentPage, filters]);

  return {
    claimsData,
    totalPages,
    currentPage,
    setCurrentPage,
    loading,
    error,
    setFilters,
    fetchClaims,
  };
};
